import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#2159f6" }, [
      _createElementVNode("path", {
        d: "M2 12.88v-1.76a1.906 1.906 0 0 1 1.9-1.9c1.81 0 2.55-1.28 1.64-2.85a1.9 1.9 0 0 1 .7-2.59l1.73-.99a1.669 1.669 0 0 1 2.28.6l.11.19c.9 1.57 2.38 1.57 3.29 0l.11-.19a1.669 1.669 0 0 1 2.28-.6l1.73.99a1.9 1.9 0 0 1 .7 2.59c-.91 1.57-.17 2.85 1.64 2.85a1.906 1.906 0 0 1 1.9 1.9v1.76a1.906 1.906 0 0 1-1.9 1.9c-1.81 0-2.55 1.28-1.64 2.85a1.9 1.9 0 0 1-.7 2.59l-1.73.99a1.669 1.669 0 0 1-2.28-.6l-.11-.19c-.9-1.57-2.38-1.57-3.29 0l-.11.19a1.669 1.669 0 0 1-2.28.6l-1.73-.99a1.9 1.9 0 0 1-.7-2.59c.91-1.57.17-2.85-1.64-2.85a1.906 1.906 0 0 1-1.9-1.9Z",
        opacity: ".32"
      }),
      _createElementVNode("path", {
        "data-name": "Vector",
        d: "M15.25 12A3.25 3.25 0 1 1 12 8.75 3.25 3.25 0 0 1 15.25 12Z"
      })
    ], -1)
  ]))]))
}
export default { render: render }